import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { AlarmClock } from "lucide-react";

export const HotelParHeureBadge = ({ onClick, mobile = false }) => {
  const [pulse, setPulse] = useState(false);

  useEffect(() => {
    const t = setInterval(() => { setPulse(true); setTimeout(() => setPulse(false), 600); }, 8000);
    return () => clearInterval(t);
  }, []);

  return (
    <NavLink
      to="/hotel-par-heure"
      onClick={onClick}
      aria-label="Hôtel par Heure — jusqu'à -50 %"
      data-testid={mobile ? "mnav-hôtel par heure" : "nav-hôtel par heure"}
      className={({ isActive }) => `badge-hotel-heure ${pulse ? "impulsion-forte" : ""} ${isActive ? "is-active" : ""} ${mobile ? "mx-3 my-1 justify-center" : "mx-1"}`}
    >
      <AlarmClock size={15} className="icone" aria-hidden="true" />
      <span>Hôtel par Heure<span className="sous-texte"> — jusqu'à -50%</span></span>
    </NavLink>
  );
};
